import ResponseError from 'components/Page/ResponseError/index';
import { STATUS_404 } from 'domain/constants/responseStatus';
import React from 'react';

const ResponseError404 = () => {
    return <ResponseError responseStatus={STATUS_404.toString()} errorText='Page not found' />;
};

export default ResponseError404;
